import { Routes } from '@angular/router';
import { PowerBiReportViewerComponent } from '@components/power-bi-report-viewer/power-bi-report-viewer.component';
import { AuthGuard } from './guards/auth.guard';
import { userLoadedResolver } from '@resolvers/user-loaded.resolver';
import { StepperComponent } from '@components/stepper/stepper.component';
import { UserAdminComponent } from './components/user-admin/user-admin.component';

import { MeasuresComponent } from './components/measures/measures.component';
import { DashboardDemoComponent } from '@components/dashboard-demo/dashboard-demo.component';
import { RoleGuard } from '@guards/role.guard';
import { ROLE_GROUPS } from './constants/roles';
import { DashboardProdComponent } from '@components/dashboard/dashboard.component';
import { IssueTrackerComponent } from '@components/issue-tracker/issue-tracker.component';

import { MipsStepperComponent } from '@components/mips-stepper/mips-stepper.component';
import { MipsFileRepositoryComponent } from '@components/mips-file-repository/mips-file-repository.component';
import { InformationHubComponent } from '@components/information-hub/information-hub.component';
import { MeetingNotesComponent } from '@components/information-hub/meeting-notes/meeting-notes.component';
import { NotificationsComponent } from '@components/information-hub/notifications/notifications.component';
import { NotificationsAdminComponent } from '@components/information-hub/notifications-admin/notifications-admin.component';
import { ReportingComponent } from '@components/reporting/reporting.component';
import { PowerBiReportsHubComponent } from '@components/power-bi-reports-hub/power-bi-reports-hub.component';
import { PowerBiCpgLandingComponent } from '@components/power-bi-cpg-landing/power-bi-cpg-landing.component';
import { AdminHubComponent } from '@components/admin-hub/admin-hub.component';
import { MipsSubmissionAdminComponent } from '@components/admin-hub/mips-submission-admin/mips-submission-admin.component';
import { MipsReviewAdminComponent } from '@components/admin-hub/mips-review-admin/mips-review-admin.component';



export const routes: Routes = [
    {
      path: 'bi',
      canActivate: [AuthGuard],
      resolve: {isLoggedIn: userLoadedResolver},
      children: [
        { path: '', component: PowerBiReportsHubComponent, pathMatch: 'full' },
        { path: 'cpg', component: PowerBiCpgLandingComponent },
        { path: ':reportId', component: PowerBiReportViewerComponent },
      ],
     },
     {
      path: '',
         component: DashboardProdComponent,
      resolve: {isLoggedIn: userLoadedResolver},
     },
     {
      path: 'demo',
         component: DashboardDemoComponent,
      resolve: {isLoggedIn: userLoadedResolver},
     },
    {
      path: 'organization',
      component: StepperComponent,
      canActivate: [AuthGuard, RoleGuard],
      resolve: {isLoggedIn: userLoadedResolver},
      data: { roles: ROLE_GROUPS.ADMIN_ROLES }

    },
    // {
    //   path: 'account', 
    //   component: AccountsettingsComponent,
    //   canActivate: [AuthGuard],
    //   resolve: {isLoggedIn: userLoadedResolver}
    // },
    {
      path: 'mipsattest',
      component: MipsStepperComponent,
      canActivate: [AuthGuard],
      resolve: {isLoggedIn: userLoadedResolver},
    },
    {
      path: 'measures', 
      component: MeasuresComponent,
      canActivate: [AuthGuard],
      resolve: {isLoggedIn: userLoadedResolver},
      data: { roles: ROLE_GROUPS.SUPER_USER }
    },
        {
      path: 'issueTracker',
      component: IssueTrackerComponent,
      canActivate: [AuthGuard],
      resolve: {isLoggedIn: userLoadedResolver},
    },
    {
      path: 'issueTracker/:id',
      component: IssueTrackerComponent,
      canActivate: [AuthGuard],
      resolve: {isLoggedIn: userLoadedResolver},
    },
    { 
      path: 'useradmin', 
      component: UserAdminComponent,
      canActivate: [AuthGuard, RoleGuard],
      resolve: {isLoggedIn: userLoadedResolver},
      data: { roles: ROLE_GROUPS.ADMIN_ROLES }
    },
    {
      path: 'mips-file-repository',
      component: MipsFileRepositoryComponent,
      canActivate: [AuthGuard, RoleGuard],
      resolve: {isLoggedIn: userLoadedResolver},
      data: { roles: ROLE_GROUPS.SUPER_USER }
    },
    // {
    //   path: 'organizationadmin',
    //   component: OrganizationAdminComponent,
    //   canActivate: [AuthGuard, RoleGuard],
    //   resolve: {isLoggedIn: userLoadedResolver},
    //   data: { roles: ROLE_GROUPS.SUPER_USER_ONLY }
    // },

    {
      path: 'information-hub',
      component: InformationHubComponent,
      canActivate: [AuthGuard],
      resolve: { isLoggedIn: userLoadedResolver },
      children: [
        { path: 'notifications', component: NotificationsComponent },
        { path: 'meeting-notes', component: MeetingNotesComponent },
        {
          path: 'administration',
          component: NotificationsAdminComponent,
          canActivate: [RoleGuard],
          data: { roles: ROLE_GROUPS.SUPER_USER },
        },
        { path: '', redirectTo: 'notifications', pathMatch: 'full' },
      ],
    },

    {
      path: 'reporting',
      component: ReportingComponent,
      canActivate: [AuthGuard],
      resolve: { isLoggedIn: userLoadedResolver },
    },

    {
      path: 'admin-hub',
      component: AdminHubComponent,
      canActivate: [AuthGuard, RoleGuard],
      resolve: { isLoggedIn: userLoadedResolver },
      data: { roles: ROLE_GROUPS.SUPER_USER },
      children: [
        { path: 'mips-submission', component: MipsSubmissionAdminComponent },
        { path: 'mips-reviews', component: MipsReviewAdminComponent },
        { path: '', redirectTo: 'mips-submission', pathMatch: 'full' },
      ],
    },

    { path: "**", redirectTo: "" }


  ];
